export default "/images/vendor/@coreui/icons/svg/flag/cif-ck.svg?cdc794a17e3e6b385219134a2257f94c";